import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/button.js';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import { Undo, Redo, Bold, Italic, Strikethrough, Code, Heading1, Heading2, Heading3, List, ListOrdered, Code2, MessageSquare, Link as Link$1, Link2Off, XCircle } from 'lucide-react';
import { useEffect, useCallback } from 'react';
import '../../lib/toast.js';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import { Color } from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import { TextStyle } from '@tiptap/extension-text-style';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

const MenuBar = ({ editor }) => {
    const setLink = useCallback(() => {
        if (!editor)
            return;
        const { from, to } = editor.state.selection;
        const selectedText = editor.state.doc.textBetween(from, to, ' ');
        let selectedLink;
        if (selectedText.startsWith('http')) {
            selectedLink = selectedText;
        }
        if (selectedText.includes('@')) {
            selectedLink = `mailto:${selectedText}`;
        }
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl || selectedLink || '');
        // cancelled
        if (url === null) {
            return;
        }
        // empty
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }
        // update link
        try {
            editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        }
        catch (e) {
            alert(e instanceof Error ? e.message : 'Failed to set link');
        }
    }, [editor]);
    if (!editor) {
        return null;
    }
    return (jsxs("div", { className: "toolbar flex flex-wrap gap-2 bg-muted p-2 rounded-t-md border border-b-0", children: [jsx("button", { type: "button", onClick: () => editor.chain().focus().undo().run(), disabled: !editor.can().chain().focus().undo().run(), className: "toolbar-item", children: jsx(Undo, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().redo().run(), disabled: !editor.can().chain().focus().redo().run(), className: "toolbar-item", children: jsx(Redo, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleBold().run(), disabled: !editor.can().chain().focus().toggleBold().run(), className: cn('toolbar-item', editor.isActive('bold') ? 'is-active' : ''), children: jsx(Bold, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleItalic().run(), disabled: !editor.can().chain().focus().toggleItalic().run(), className: cn('toolbar-item', editor.isActive('italic') ? 'is-active' : ''), children: jsx(Italic, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleStrike().run(), disabled: !editor.can().chain().focus().toggleStrike().run(), className: cn('toolbar-item', editor.isActive('strike') ? 'is-active' : ''), children: jsx(Strikethrough, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleCode().run(), disabled: !editor.can().chain().focus().toggleCode().run(), className: cn('toolbar-item', editor.isActive('code') ? 'is-active' : ''), children: jsx(Code, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(), className: cn('toolbar-item', editor.isActive('heading', { level: 1 }) ? 'is-active' : ''), children: jsx(Heading1, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(), className: cn('toolbar-item', editor.isActive('heading', { level: 2 }) ? 'is-active' : ''), children: jsx(Heading2, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(), className: cn('toolbar-item', editor.isActive('heading', { level: 3 }) ? 'is-active' : ''), children: jsx(Heading3, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleBulletList().run(), className: cn('toolbar-item', editor.isActive('bulletList') ? 'is-active' : ''), children: jsx(List, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleOrderedList().run(), className: cn('toolbar-item', editor.isActive('orderedList') ? 'is-active' : ''), children: jsx(ListOrdered, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleCodeBlock().run(), className: cn('toolbar-item', editor.isActive('codeBlock') ? 'is-active' : ''), children: jsx(Code2, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleBlockquote().run(), className: cn('toolbar-item', editor.isActive('blockquote') ? 'is-active' : ''), children: jsx(MessageSquare, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: setLink, className: cn('toolbar-item', editor.isActive('link') ? 'is-active' : ''), children: jsx(Link$1, { className: "h-4 w-4" }) }), jsx("button", { type: "button", className: cn('toolbar-item', editor.isActive('link') ? 'is-active' : ''), onClick: () => editor.chain().focus().unsetLink().run(), disabled: !editor.isActive('link'), children: jsx(Link2Off, { className: "h-4 w-4" }) }), jsx("button", { type: "button", onClick: () => editor.chain().focus().unsetAllMarks().run(), className: "toolbar-item", children: jsx(XCircle, { className: "h-4 w-4" }) })] }));
};
const extensions = [
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    TextStyle,
    StarterKit.configure({
        bulletList: {
            keepMarks: true,
            keepAttributes: false,
        },
        orderedList: {
            keepMarks: true,
            keepAttributes: false,
        },
        // Disable built-in link extension to avoid conflicts with custom Link configuration below
        link: false,
    }),
    Link.configure({
        openOnClick: false,
        autolink: true,
        defaultProtocol: 'https',
        protocols: ['http', 'https', 'mailto'],
        isAllowedUri: (url, ctx) => {
            try {
                if (url.startsWith('mailto:')) {
                    return true;
                }
                // construct URL
                const parsedUrl = url.includes(':')
                    ? new URL(url)
                    : new URL(`${ctx.defaultProtocol}://${url}`);
                // use default validation
                if (!ctx.defaultValidate(parsedUrl.href)) {
                    return false;
                }
                // disallowed protocols
                const disallowedProtocols = ['ftp', 'file'];
                const protocol = parsedUrl.protocol.replace(':', '');
                if (disallowedProtocols.includes(protocol)) {
                    return false;
                }
                // only allow protocols specified in ctx.protocols
                const allowedProtocols = ctx.protocols.map(p => (typeof p === 'string' ? p : p.scheme));
                if (!allowedProtocols.includes(protocol)) {
                    return false;
                }
                // disallowed domains
                const disallowedDomains = [];
                const domain = parsedUrl.hostname;
                if (disallowedDomains.includes(domain)) {
                    return false;
                }
                // all checks have passed
                return true;
            }
            catch {
                return false;
            }
        },
        shouldAutoLink: url => {
            try {
                // construct URL
                const parsedUrl = url.includes(':') ? new URL(url) : new URL(`https://${url}`);
                // only auto-link if the domain is not in the disallowed list
                const disallowedDomains = [];
                const domain = parsedUrl.hostname;
                return !disallowedDomains.includes(domain);
            }
            catch {
                return false;
            }
        },
    }),
];
/**
 * Rich text editor component powered by TipTap
 * Provides a WYSIWYG editor with formatting toolbar
 */
const RichTextEditor = ({ className, value, onChange, ...props }) => {
    const editor = useEditor({
        extensions,
        content: value,
        onUpdate({ editor }) {
            onChange?.(editor.getHTML());
        },
        editorProps: {
            attributes: {
                class: 'editor-input',
            },
        },
    });
    // Update editor content when value prop changes externally
    useEffect(() => {
        if (editor && value !== undefined && value !== editor.getHTML()) {
            editor.commands.setContent(value);
        }
    }, [editor, value]);
    /**
     * Handle click on editor container to focus editor
     * Allows clicking anywhere in the editor box to start typing
     */
    const handleEditorClick = useCallback(() => {
        if (editor) {
            editor.commands.focus();
        }
    }, [editor]);
    return (jsxs("div", { className: cn('editor-container rounded-md w-full border', className), ...props, children: [jsx(MenuBar, { editor: editor }), jsx("div", { className: "editor-inner tiptap cursor-text", style: { minHeight: '200px' }, onClick: handleEditorClick, children: jsx(EditorContent, { editor: editor }) })] }));
};

export { RichTextEditor };
//# sourceMappingURL=RichTextEditor.js.map
